import { createContext, FC, useContext, useMemo } from 'react';

import { useLandlordConstants } from '@shared/contexts/ConfigContext';
import { CoreOptionsProvider, useCoreOptions, UseCoreOptionsResult } from '@shared/contexts/OptionsContext';
import { ConfigLandlordConstants } from '@shared/models/config';

// import { useConfig } from '@core/contexts/ConfigContext';

const getOptionsValue = (_: ConfigLandlordConstants) => {
  return {
    // TODO: Empty for now, no difference between agency and landlord
  };
};

interface UseOptionResult extends ReturnType<typeof getOptionsValue>, UseCoreOptionsResult {}

const OptionsContext = createContext<UseOptionResult>({} as UseOptionResult);

export const useOptions = () => {
  return useContext(OptionsContext);
};

const OptionsProvider: FC = ({ children }) => {
  const coreOptions = useCoreOptions();

  const { constants } = useLandlordConstants();

  const result = useMemo(() => ({ ...coreOptions, ...getOptionsValue(constants) }), [constants, coreOptions]);

  return <OptionsContext.Provider value={result}>{children}</OptionsContext.Provider>;
};

export const CombinedOptionsProvider: FC = ({ children }) => (
  <CoreOptionsProvider>
    <OptionsProvider>{children}</OptionsProvider>
  </CoreOptionsProvider>
);
